import { useT } from '../../i18n'

interface Props {
  title: string
  lines: string[]
  accent: string
  /** Game box art shown left of the title. */
  image?: string
  onClose: () => void
}

/**
 * The "How to play" card both word games open from the pill above
 * their score card. Plain lines, one thought each, one button out.
 */
export function HowToOverlay({ title, lines, accent, image, onClose }: Props) {
  const t = useT()
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-6"
         onClick={onClose}>
      <div className="w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl"
           onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3">
          {image && (
            <img src={image} alt={title}
                 className="w-14 h-14 rounded-2xl object-cover shrink-0 shadow-xs" />
          )}
          <div className="min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-brand-muted">
              {t('How to play')}
            </p>
            <h2 className="font-display font-bold text-2xl uppercase tracking-wide mt-0.5"
                style={{ color: accent }}>
              {title}
            </h2>
          </div>
        </div>
        <div className="mt-3 space-y-2.5">
          {lines.map(line => (
            <p key={line} className="text-sm text-brand-text leading-relaxed">{line}</p>
          ))}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="w-full mt-5 py-3 rounded-2xl font-display font-bold text-white
                     active:scale-[0.98] transition-transform"
          style={{ backgroundColor: accent }}
        >
          {t('Got it')}
        </button>
      </div>
    </div>
  )
}
